package com.vizio.redwolf.auth.model

data class RequiresVerificationRequestInfo(val accessToken: String)